import Styled from 'styled-components';

export const Container = Styled.div`
    position: relative;
    height: calc(100% - 100px);
`

export const HeaderContainer = Styled.div`
    background-color: var(--color-neutral-background);
    display: flex;
    height: 100px;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`